import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=8413ba76&"
import script from "./main-footer.ts?vue&type=script&lang=ts&"
export * from "./main-footer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports